$(function() {

  $.scrollify({
    section : ".panel",
    sectionName : "section-name",
    scrollbars: true,
    before:function(i,panels) {
      
      var ref = panels[i].attr("data-section-name");
      
      $(".pagination .active").removeClass("active");
      $(".pagination").find("a[href=\"#" + ref + "\"]").addClass("active");

      $(".product-image.active").removeClass("active");
      $(".product-image.pl-image-"+ ref).addClass("active");

    },
    after:function(i,panels) {

    },
    afterResize:function() {},
    afterRender:function() {}
  });

  $(".pagination a").on("click",function() {
    $.scrollify.move($(this).attr("href"));
  });

  $(document).scroll(function() {
    checkOffset();
  });
  
  function checkOffset() {

    if( $('.product-image').offset().top + $('.product-image').height() >= $('.footer').offset().top - 230 || $('.product-image').offset().top < 300 )
        $('.product-image').css('position', 'absolute');
    if( $(document).scrollTop() + window.innerHeight < $('.footer').offset().top && $(document).scrollTop() >= 300 )
        $('.product-image').css('position', 'fixed'); // restore when you scroll up
  }

});
